import { EChartsOption } from 'echarts';

// 调色盘颜色列表
export const colorPlan = [
  'rgba(73, 126, 227, 1)',
  'rgba(49, 192, 170, 1)',
  'rgba(84, 87, 150, 1)',
  'rgba(250, 126, 81, 1)',
  'rgba(47, 179, 210, 1)',
  'rgba(128, 92, 180, 1)',
  'rgba(177, 214, 129, 1)',
  'rgba(139, 140, 171, 1)',
  'rgba(249, 204, 20, 1)',
];
// 提示框浮层的背景颜色
export const tooltipBackgroundColor = '#253044';

export const iconLinePath =
  'path://M399.5,0C401.4329833984375,0,403,1.5670033693313599,403,3.5C403,5.43299674987793,401.4329833984375,7,399.5,7C397.5670166015625,7,396,5.43299674987793,396,3.5C396,1.5670033693313599,397.5670166015625,0,399.5,0ZM395.1302795410156,2.4206178188323975C395.045166015625,2.766411304473877,395,3.12793231010437,395,3.5C395,3.9152348041534424,395.0562438964844,4.317333698272705,395.1615295410156,4.699095249176025L392,4.698750972747803L392,2.4206576347351074L395.1302795410156,2.4206178188323975ZM407,2.4206576347351074L407,4.698750972747803L403.8384704589844,4.699095249176025C403.9437561035156,4.317333698272705,404,3.9152348041534424,404,3.5C404,3.12793231010437,403.954833984375,2.766411304473877,403.8697204589844,2.4206178188323975L407,2.4206576347351074Z';

export const iconBarPath =
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjhweCIgdmlld0JveD0iMCAwIDggOCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDx0aXRsZT7nn6nlvaI8L3RpdGxlPgogICAgPGcgaWQ9Iumhtemdoi0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0i5p+x54q25oqY57q/5Zu+IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODAyLjAwMDAwMCwgLTM4Ny4wMDAwMDApIiBmaWxsPSIjNDk3RUUzIj4KICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC015aSH5Lu9IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2NjEuMDAwMDAwLCAxMjguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0i57yW57uELTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0MS4wMDAwMDAsIDI1NC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0i55+p5b2iIiB4PSIwIiB5PSI1IiB3aWR0aD0iOCIgaGVpZ2h0PSI4IiByeD0iMSI+PC9yZWN0PgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=';
export function getLineOptions() {
  return {
    title: {
      text: '',
    },
    tooltip: {
      trigger: 'axis',
      padding: [10, 10, 10, 10],
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: 'rgba(202, 217, 224, 0.2)',
          type: 'solid',
          width: 60,
        },
      },
      confine: true,
      backgroundColor: tooltipBackgroundColor,
      borderRadius: 4,
      borderColor: '#17212C',
      textStyle: {
        color: 'white',
      },
    },
    legend: {
      type: 'scroll',
      bottom: '0',
      itemGap: 32,
      itemWidth: 12,
      itemHeight: 12,
      textStyle: {
        fontSize: 12,
        color: '#354052',
      },
      icon: 'roundRect',
      data: [],
    },
    grid: {
      top: 20,
      left: 20,
      right: 36,
      bottom: 40,
      containLabel: true,
    },
    xAxis: {
      axisLine: {
        lineStyle: {
          color: '#DFE3EB',
        },
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: '#B9BCC3',
        fontSize: 12,
        margin: 16,
      },
      boundaryGap: true,
      data: [],
    },
    yAxis: [],
    series: [],
    color: colorPlan,
  } as EChartsOption;
}
